import { Components, Theme } from "@mui/material";

export const MuiDialog: Components<Omit<Theme, "MuiDialog">>["MuiDialog"] = {
  styleOverrides: {
    root: {
      "& .MuiInputBase-root": {
        background: "#F8F8F8",
      },
    },
  },
};
